import { StateService } from "@uirouter/angularjs";
import { $confirm } from "../../../../@custom_types/confirm";
import { Record } from "../../../records/server/crud";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";

export class MealLogEntryDetailController {
  static $inject = [ServerUtilityName, "$confirm", "$state"];

  constructor(
    private readonly serverUtility: ServerUtility,
    private readonly $confirm: $confirm,
    private readonly $state: StateService
  ) {}

  mealLog!: Record;
  info: any;

  afterDelete!: ({}) => Promise<any>;

  delete() {
    this.$confirm({ text: "Are you sure you want to delete this entry?" }).then(
      () =>
        this.serverUtility
          .delete({
            url: "/api/machines/mealLog",
            id: this.mealLog.Id,
          })
          .then(() => this.afterDelete({ mealLog: this.mealLog }))
    );
  }
}
